import * as React from 'react';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { ApiStore } from '../../stores/ApiStore';
import * as ApiTypes from '../../models/ApiTypes';
import { bind, inject } from '../../utils/decorators';
import { FormGroup, ControlLabel, FormControl, Button, InputGroup, Modal } from 'react-bootstrap';
import FaIcon from '../site/FaIcon';

interface IObjektMessmittelUebernehmenProps {
  kategorie: string;
  onUebernehme: (adresse: ApiTypes.IMessmittelUO) => void;
}

/** Komponente zur Übernahme der Daten eines ÜO Messmittels in das Laborumfeld */
@observer
class ObjektMessmittelUebernehmen extends React.Component<IObjektMessmittelUebernehmenProps, {}> {

  @inject(ApiStore) apiStore: ApiStore;

  @observable kennung: string = '';
  @observable messmittelVorhanden: boolean = false;
  @observable requestInProgress: boolean = false;

  private abrufTimeoutRef: number = 0;

  @bind @action setRequestInProgress(value: boolean) {
    this.requestInProgress = value;
  }

  pruefeMessmittelVorhandenDelayed() {
    if (this.abrufTimeoutRef > 0) {
      window.clearTimeout(this.abrufTimeoutRef);
      this.abrufTimeoutRef = 0;
    }
    const validateTimeoutInMs = 500;
    this.abrufTimeoutRef = window.setTimeout(() => { this.pruefeMessmittelVorhanden(); }, validateTimeoutInMs);
  }

  @bind @action async pruefeMessmittelVorhanden() {
    if (this.kennung !== '') {
      this.setRequestInProgress(true);
      const response = await this.apiStore.messmittelVorhanden(this.props.kategorie, this.kennung);
      if (response.ok) {
        this.setMmVorhanden(response.json.vorhanden);
      }
      this.setRequestInProgress(false);
    } else {
      this.setMmVorhanden(false);
    }
  }

  @bind @action setMmVorhanden(value: boolean) {
    this.messmittelVorhanden = value;
  }

  @bind @action async uebernehme() {
    if (this.kennung !== '') {
      const response = await this.apiStore.messmittelDaten(this.props.kategorie, this.kennung);
      if (response.ok) {
        this.props.onUebernehme(response.json);
      }
    }
  }

  @bind @action handleMmKennungChanged(event: React.FormEvent<FormControl>) {
    this.kennung = (event.target as HTMLInputElement).value;
    this.pruefeMessmittelVorhandenDelayed();
  }

  renderAbfrageStatus() {
    if (this.kennung === '') {
      return <div style={{marginTop: '15px'}}>&nbsp;</div>;
    }
    if (this.requestInProgress) {
      return <div style={{marginTop: '15px'}}><FaIcon icon="spinner" />Daten werden abgerufen...</div>;
    }
    if (this.messmittelVorhanden) {
      return <div className="value-success" style={{marginTop: '15px'}}><FaIcon icon="check" />Zu diesem Messmittel liegen Daten der ÜO vor</div>;
    }
    if (this.messmittelVorhanden === false) {
      return <div style={{marginTop: '15px'}}><FaIcon icon="question" />Zu diesem Messmittel liegen keine Daten der ÜO vor</div>;
    }
    // @todo: Vorlage prüfen
    return <div style={{marginTop: '15px'}}>&nbsp;</div>;
  }

  render() {
    return (
      <div style={{marginTop: '15px'}}>
        <FormGroup controlId="MMKennung">
          <ControlLabel>Kennung der ÜO</ControlLabel>
            <InputGroup>
              <FormControl type="text" label="Kennung" placeholder="z.B. Kennung der ÜO" onChange={this.handleMmKennungChanged} value={this.kennung}/>
              <InputGroup.Button>
                <Button bsStyle="success" className="btn-group" disabled={!this.messmittelVorhanden} onClick={() => this.uebernehme()}>Übernehmen</Button>
              </InputGroup.Button>
            </InputGroup>
            {this.renderAbfrageStatus()}
        </FormGroup>
      </div>);
  }
}

interface IObjektMessmittelUebernehmenModalProps {
  kategorie: string;
  show: boolean;
  onUebernehme: (adresse: ApiTypes.IMessmittelUO) => void;
  onHideModal: () => void;
}

/** Modaler Dialog für Datenübernahme */
@observer
export default class ObjektMessmittelUebernehmenModal extends React.Component<IObjektMessmittelUebernehmenModalProps> {

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.onHideModal} className="modal-vertical-centered" backdrop={'static'}>
        <Modal.Header closeButton={true}>
          <Modal.Title>Daten aus Messmittel übernehmen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>Die Daten für das neue Objekt können über die Messmittelkennung einer ÜO übernommen werden.</div>
          <ObjektMessmittelUebernehmen onUebernehme={this.props.onUebernehme} kategorie={this.props.kategorie}/>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.onHideModal} bsStyle="default">Abbrechen</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/objekte/ObjektMessmittelUebernehmen.tsx